/**
 * Turn a video share link into an embeddable iframe URL.
 * Only hosts we trust are embedded; anything else returns null and should be
 * rendered as a plain external link instead (DB content must never inject
 * arbitrary iframes).
 */
export function getEmbedUrl(url: string): string | null {
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return null;
  }
  if (parsed.protocol !== 'https:') return null;

  const host = parsed.hostname.toLowerCase();

  // Loom: https://www.loom.com/share/<id> → https://www.loom.com/embed/<id>
  if (host === 'www.loom.com' || host === 'loom.com') {
    const match = parsed.pathname.match(/^\/(?:share|embed)\/([a-zA-Z0-9]+)/);
    if (match) return `https://www.loom.com/embed/${match[1]}`;
    return null;
  }

  // YouTube: watch?v=<id>, youtu.be/<id>, shorts/<id> → youtube-nocookie embed
  if (host === 'www.youtube.com' || host === 'youtube.com' || host === 'youtu.be') {
    let id: string | null = null;
    if (host === 'youtu.be') {
      id = parsed.pathname.slice(1).split('/')[0] || null;
    } else if (parsed.pathname === '/watch') {
      id = parsed.searchParams.get('v');
    } else {
      const match = parsed.pathname.match(/^\/(?:embed|shorts)\/([a-zA-Z0-9_-]+)/);
      if (match) id = match[1];
    }
    if (id && /^[a-zA-Z0-9_-]{5,20}$/.test(id)) {
      return `https://www.youtube-nocookie.com/embed/${id}`;
    }
    return null;
  }

  return null;
}
